import { appDependencies } from "../AppDependencies";
import { appDomain, appEmit } from "../AppDomain";
import { EnumMessageToDisplayType } from "../notifications/EnumMessageToDisplayType";
import { EventNames } from "../events/Events";
import { NotAuthenticatedError } from "../authentication/TokenErrors";
import { ValidationError } from "./ValidationError";
import { IHandleExceptions } from "./IHandleExceptions";

export class ExceptionService implements IHandleExceptions {
    handleException(exception: any) {
        if (exception.ngDebugContext && exception.ngDebugContext.component) {
            console.warn("Exception in component: ", exception.ngDebugContext.component);
            if (exception.ngDebugContext.renderNode) {
                const node = exception.ngDebugContext.renderNode as Node;
                console.warn("While rendering DOM nodes:", node.parentNode, node, node.nextSibling);
            }
            console.warn(exception.ngDebugContext);
            console.warn(exception);
        }

        if (exception instanceof ValidationError) {
            console.log("Validation errors:", (exception as ValidationError).validationResults);
            appEmit(EventNames.validationError, exception);
            return;
        }

        if (exception instanceof Error && (exception as any).xhr) {
            const xhr = (exception as any).xhr.rawRequest as XMLHttpRequest;

            if (xhr.status === 401) {
                appDomain.IAuthenticationService.loginRedirect();
                return;
            }

            if (xhr.status === 422) {
                const validationResults = JSON.parse(xhr.response).results.map((y: any) => appDependencies.ICanTranslate.translate(y.message, y.parameters)).join(", ");
                appDependencies.ICanShowAlert.error(appDependencies.ICanTranslate.translate("general.validation-error"), validationResults);
                return;
            }

            appDependencies.ICanNotify.notify({
                title: `Httperror, Status: ${xhr.status}`, body: xhr.responseURL, type: EnumMessageToDisplayType.error
            });
            return;
        }

        if (exception instanceof NotAuthenticatedError) {
            appDomain.IAuthenticationService.loginRedirect();
            return;
        }

        if (exception instanceof Event) {
            console.log("Exception event:", exception);
            return;
        }

        if (exception instanceof Error) {
            console.log("Error event:", exception);
            return;
        }

        const error = new Error("Domain error not handled");
        console.warn(error, exception);
        throw error;
    }
}
